import styled from 'styled-components';

export const HeaderRoot = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
`;

export const HelpConfigStyles = { height: '220px', maxWidth: '400px', marginRight: '70px', marginLeft: 'auto' };
